import RecommendationProducts from './recommendation-products-controller'

export default RecommendationProducts
